import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as actions from '../redux/actions/analyticsActions';
import {AnalyticsEvent} from '../redux/types/analytics';
import {AppState} from 'redux/reducers';

export {AnalyticsEvent} from '../redux/types/analytics';

export function useAnalytics() {
    const abflags = useSelector((state: AppState) => state.abflags);
    const dispatch = useDispatch();
    const useSqsLogging = abflags?.useQueueLogging;
    const track = useCallback((...args: Parameters<typeof actions.track>) => {
        dispatch(actions.track(args[0], {...args[1], abflags, useSqsLogging}));
    }, []);

    return {
        AnalyticsEvent,
        track,
    };
}
